import Vue from 'vue'

const quickFilterClicked = ({
  action, businessType, filters, text,
}) => {
  const data = {
    quickFilter: {
      action,
      businessType,
      filters,
      text,
    },
    event: 'quickFilterClicked',
  }

  Vue.$clickstream.trackEvent(data)
}

export default {
  quickFilterClicked,
}
